export default __webpack_public_path__ + "static/media/Icons_Electric_Fill_Grey Icon.0d108941.svg";